// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { CacheLookupPolicy } from '@azure/msal-browser'
import { UnauthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react'
import { Button, CircularProgress, Typography } from '@mui/material'
import React from 'react'
import Container from '../../common/container/Container'
import Page from '../../common/page/Page'
import Header from '../header/Header'
import { i18n } from '../index'
import { loginRequest } from './MsalConfig'
import authStore from './authStore'
import css from './loginPage.css'

type TokenCallState = 'NOT_STARTED' | 'IN_PROGRESS' | 'DONE' | 'ERROR'

const LoginPage = () => {
  const { instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const [tokenCallState, setTokenCallState] = React.useState<TokenCallState>('NOT_STARTED')

  const account = instance.getActiveAccount()
  const user = authStore.user

  const login = (): void => {
    instance.loginRedirect(loginRequest).catch((err) => console.log(err))
  }

  React.useEffect(() => {
    if (isAuthenticated && tokenCallState === 'NOT_STARTED') {
      setTokenCallState('IN_PROGRESS')
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account,
          cacheLookupPolicy: CacheLookupPolicy.AccessTokenAndRefreshToken,
        })
        .then((tokenResponse) => {
          return fetch(`${process.env.REACT_APP_API_URL}/token`, {
            method: 'GET',
            headers: {
              authorization: `Bearer ${tokenResponse.accessToken}`,
            },
          })
        })
        .then((response) => {
          if (response.status !== 200) {
            throw new Error('Failed to authenticate user')
          }
          setTokenCallState('DONE')
        })
        .catch((err) => {
          console.log(err)
          setTokenCallState('ERROR')
          instance.logout({
            account: instance.getActiveAccount() ?? undefined,
            postLogoutRedirectUri: process.env.REACT_APP_LOGIN_REDIRECT_URI as string,
          })
        })
    }
  }, [isAuthenticated, account, tokenCallState, instance, user])

  if (isAuthenticated && tokenCallState === 'DONE') {
    window.location.href = '/'
  }

  if (tokenCallState === 'IN_PROGRESS') {
    return (
      <Page>
        <Container>
          <CircularProgress />
        </Container>
      </Page>
    )
  }
  const env = process.env.REACT_APP_ENVIRONMENT ?? 'dev'
  const appTitle = ['test', 'dev'].includes(env) ? `Mojova ${env.toUpperCase()}` : 'Mojova'

  return (
    <Page>
      <Header title={i18n.t('login.header')} showNav={false} showLogoOnMobile />
      <UnauthenticatedTemplate>
        <Container>
          <div className={css.content}>
            <Typography variant='h4' className={css.title}>
              {appTitle}
            </Typography>
            <Button className={css.button} color='primary' variant='contained' size='large' onClick={login}>
              {i18n.t('buttons.login')}
            </Button>
          </div>
        </Container>
      </UnauthenticatedTemplate>
    </Page>
  )
}

export default LoginPage
